export default "__VITE_ASSET__CDTjaeLp__$_?url__"